<template>
    <Schedule
      :id="id"
      :fields="fields"
      :data="data"
      :code="code"
      :config="config"
      :months="undefined"
      :tournDates="tournDates"
      :newReports="newReports"
    />
</template>

<script>
import { Schedule } from "@ocs-software/vue-ocs";
export default {
  name: "Schedule Table",
  props: ["id", "fields", "data", "code", "search", "months", "tournDates" , "newReports", "config"],
  components: {
    Schedule
  },
  filters: {
    base: function(value) {
      return btoa(value);
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (this.code === item.code) return "live";
    },
  },
  computed: {
    filteredList() {
      return this.data.filter(item => {
        const query = this.search.toLowerCase(); 
        return item.full_name.toLowerCase().includes(query);
      })
    },
  },
};
</script>

<style scoped src="@/css/schedule.css"></style>
